import { DealHistory } from "../../models/history";

export const initialHistoryState: DealHistory = {
  events: [],
  dealId: ""
};
